import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Messages } from '../shapes';


const MessagesSvg = (props) => (
  <g>
    <IconBounds />
    <Messages {...props} />
  </g>
);

MessagesSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

MessagesSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default MessagesSvg;
